import React, { useState, useEffect } from "react";
import Footer from "../../CustomComponents/Footer/Footer";
import Header from "../../CustomComponents/Header/Header";
import OurQuery from "../../CustomComponents/OurQuery/OurQuery";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import {
  calculateLOS,
  currentDateSingle,
  formatIndianCurrency,
  scrollToTop,
} from "../../utils/utils";
import moment from "moment";
import imgNotFound from "../../assets/images/single-image.png";
import TransportTabHeader from "../../CustomComponents/TransportCustomTabHeader/TransportTabHeader";
import OgMetaTitles from "../../CustomComponents/PageMetaData/OgMetaTitles";
import NewSendEnquiryPopup from "../../CustomComponents/NewSendEnquiryPopup/NewSendEnquiryPopup";
import PageMetaData from "../../CustomComponents/PageMetaData/PageMetaData";
import TransportOverviewContent from "../../CustomComponents/TransportCustomTabHeader/TransportOverviewContent";
import TransportItineraryContent from "../../CustomComponents/TransportCustomTabHeader/TransportItineraryContent";
import TransportInclusionExclusionContent from "../../CustomComponents/TransportCustomTabHeader/TransportInclusionExclusionContent";
import TransportCancellation from "../../CustomComponents/TransportCustomTabHeader/TransportCancellation";
import TransportGallery from "../../CustomComponents/TransportCustomTabHeader/TransportGallery";
import TransportPointRemember from "../../CustomComponents/TransportCustomTabHeader/TransportPointRemember";
import SinglePackageHeader from "../../CustomComponents/SinglePackageHeader/SinglePackageHeader";
import SingleTransportHeader from "../../CustomComponents/SinglePackageHeader/SingleTransportHeader";
import NewUiHeader from "../../CustomComponents/NewComponents/NewUIHeader/NewUIHeader";
import EditNewUiSearchFormTransport from "../../CustomComponents/NewComponents/NewUiSearchForm/NewUiSearchFormTransport/EditNewUiSearchFormTransport";
import styles from "./NewUiSingleTransport.module.scss";
import {
  SvgAccordion,
  SvgClock,
  SvgDownload,
  SvgEmail,
  SvgLocation,
  SvgPrint,
  SvgWhatsapp,
  CrossWithBorder,
} from "../../utils/svgIcons";
import NewFooterUI from "../../CustomComponents/NewComponents/NewFooterUI/NewFooterUI";
import PackageDetails from "../../CustomComponents/ButtonToDownload/PackageDetails";
import NewShare from "../../CustomComponents/NewComponents/NewShareMailPrint/NewShare";
import NewMail from "../../CustomComponents/NewComponents/NewShareMailPrint/NewMail";
import NewPrint from "../../CustomComponents/NewComponents/NewShareMailPrint/NewPrint/NewPrint";
import Skeleton from "react-loading-skeleton";

function NewUiSingleTransport() {
  const [date, setDate] = useState({
    setDay: "",
    setMonth: "",
    setYear: "",
  });
  const { transportHandle } = useParams();
  const [isSliderVisible, setIsSliderVisible] = useState(false);
  const [showRatePopup, setshowRatePopup] = useState(false);
  const [loader, setLoader] = useState(true);
  const [selectedAddOns, setSelectedAddOns] = useState([]);

  const [selectedMealPlan, setSelectedMealPlan] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState("sedan");
  const [ACtype, setACtype] = useState("withoutAC");
  const [openGetQuotePopup, setOpenGetQuotePopup] = useState(false);

  const handleSelectVehicleChange = (e) => {
    setSelectedVehicle(e.target.value);
  };

  const location = useLocation();

  const navigate = useNavigate();

  const [singlePackage, setSinglePackage] = useState({});

  const [selectedCategory, setSelectedCategory] = useState("");
  const [ratesOfPackages, setRatesOfPackages] = useState(null);
  const [guest, setGuest] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [singleTransportData, setSingleTransportData] = useState({});
  const [activePayment, setActivePayment] = useState("priceSummary");
  const [paymentDetails, setPaymentDetails] = useState(true);
  const [mobilePriceBreakup, setMobilePriceBreakup] = useState(false);
  const [priceBreakupPopup, setPriceBreakupPopup] = useState(false);
  const [allPackageHotels, setAllPackageHotels] = useState([]);
  const [packageRates, setPackageRates] = useState([]);
  const [markupData, setMarkupData] = useState([]);
  const [promotions, setPromotions] = useState([]);
  const [openOuterAccordion, setOpenOuterAccordion] = useState([
    "detailed_itinerary",
  ]);
  const [selectedDiscount, setSelectedDiscount] = useState([]);
  const [selectedAutomaticDiscount, setSelectedAutomaticDiscount] = useState(
    []
  );

  const handleDetailedFilter = (value) => {
    setDetailedFilter(value);
  };

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const detailedItinerary = [
    { label: "Overview", value: "overview" },
    // {
    //   label: singlePackage.totalDays + " " + "Days Itinerary",
    //   value: "itinerary",
    // },
    // { label: "Accommodation", value: "accommodation" },
    { label: "Gallery", value: "gallery" },
  ];

  const [filter, setFilter] = useState("detailed_itinerary");
  const [detailedFilter, setDetailedFilter] = useState("overview");
  const [openIndex, setOpenIndex] = useState(0);

  const { includingDestinations } = location?.state || {};

  const userType = localStorage.getItem("userType");
  const userDetails = JSON?.parse(localStorage?.getItem("userDetails"));
  const userToken = localStorage.getItem("token");
  const [commission, setCommission] = useState({});
  const [packageId, setPackageId] = useState(null);
  const [allDestinations, setAllDestinations] = useState([]);
  // markup fetch api
  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          if (findObject) {
            setMarkupData(findObject);
          } else {
            setMarkupData(null);
          }
        } else {
          setMarkupData("No data found");
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchMarkup();
  }, []);

  const handleSelectedAddOns = (addon) => {
    setSelectedAddOns((prevSelected) => {
      const isSelected = prevSelected.some(
        (selected) => selected.id === addon.id
      );
      if (isSelected) {
        return prevSelected.filter((selected) => selected.id !== addon.id);
      } else {
        return [...prevSelected, addon];
      }
    });
  };

  useEffect(() => {
    const updateHideToggle = () => {
      if (window.innerWidth <= 768) {
        setMobilePriceBreakup(true);
      } else {
        setMobilePriceBreakup(false);
      }
    };

    updateHideToggle(); // Set the initial state based on screen size
    window.addEventListener("resize", updateHideToggle);

    return () => window.removeEventListener("resize", updateHideToggle);
  }, []);

  const togglePaymentDetails = () => {
    setPaymentDetails(!paymentDetails);
  };

  const handleButtonClick = () => {
    setActivePayment((prev) =>
      prev === "priceSummary" ? "priceDetails" : "priceSummary"
    );
  };

  const [formData, setFormData] = useState({
    company_name: "",
    name: "",
    phone: "",
    email: "",
    querry_detail: "",
    country: "",
    state: "",
    city: "",
    address: "",
  });

  const [activeTab, setActiveTab] = useState("package-information");

  const renderContent = () => {
    switch (activeTab) {
      case "package-information":
        return (
          <TransportOverviewContent
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      case "package-itinerary":
        return (
          <TransportItineraryContent
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      // case "package-hotels":
      //     return (
      //         <AccommodationContent
      //             loader={loader}
      //             singleTransportData={singleTransportData}
      //             setSelectedCategory={setSelectedCategory}
      //             selectedCategory={selectedCategory}
      //             setSelectedMealPlan={setSelectedMealPlan}
      //             selectedMealPlan={selectedMealPlan}
      //             allPackageHotels={allPackageHotels}
      //             packageRates={packageRates}
      //             ratesOfPackages={ratesOfPackages}
      //         />
      //     );
      case "package-destinations":
        return (
          <TransportInclusionExclusionContent
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      case "package-cancellation":
        return (
          <TransportCancellation
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      case "package-remember":
        return (
          <TransportPointRemember
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      case "package-gallery":
        return (
          <TransportGallery
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (packageRates.length > 0) {
      setSelectedMealPlan(packageRates[0]?.mealPlan);
    }
  }, [packageRates.length]);

  const [bookingData, setBookingData] = useState({});

  const commissionAmount = commission?.commissionAmount;
  const commissionType = commission?.commissionType;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }
    const data = {
      location: params.get("location"),
      room: params.get("room"),
      guest: params.get("guest"),
      children: params.get("children"),
      departureDay: params.get("checkinDay"),
      departureMonth: params.get("checkinMonth"),
      departureYear: params.get("checkinYear"),
      radio: params.get("radio"),
      childAge: childAges,
      date: params.get("date"),
      day: params.get("day"),
      month: params.get("month"),
      year: params.get("year"),
      packageId: params.get("packageId"),
      transportHandle: transportHandle,
    };

    setDate({
      setDay: data.day,
      setMonth: data.month,
      setYear: data.year,
    });

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/transport-holidays/fetch/single/${transportHandle}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setLoader(false);
        setSingleTransportData(data?.data);
        setSinglePackage(data?.data);
        setPackageId(data?.data?.packageId);
        // setSelectedCategory(
        //   data?.data?.packageHotels[0]?.accommodationCategory
        // );
        // if (data?.data?.packageItinerary[0]?.accommodation.length === 0) {
        //   showErrorToast("Accommodations are not added in this package.")
        //   return
        // }
        setSelectedCategory(
          data?.data?.hotelCategory[0]
          // data?.data?.packageItinerary[0]?.accommodation[0]?.hotelcategory
        );

        const allAccommodations = data?.data?.packageItinerary.flatMap(
          (item) => item.accommodation
        );

        if (allAccommodations) {
          const uniqueAccommodations = Array.from(
            new Map(
              allAccommodations?.map((hotel) => [hotel?.accommodationId, hotel])
            ).values()
          );
          setAllPackageHotels(uniqueAccommodations);
        }

        setPackageRates(data?.data?.packageRates);
        scrollToTop();
      })
      .catch((error) =>
        console.error(
          "There has been a problem with your fetch operation:",
          error
        )
      );

    const checkInDate = `${data.year}-${String(data.month).padStart(
      2,
      "0"
    )}-${String(data.date).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    setGuest(data.guest);

    if (data.date && data.month && data.year) {
      setStartDate(checkInDate);
    } else {
      setStartDate(currentDateSingle);
    }
    // setStartDate(checkInDate);
    setEndDate(checkOutDate);
    setBookingData({ ...data, travelDate: startDate });

    fetchPromotions({
      checkInDateFromBooking: checkInDate,
      packageIdFromBooking: Number(data?.packageId),
    });
  }, [location.search]);

  const totalAddonsCostWithoutCommission = selectedAddOns?.reduce(
    (total, addon) => {
      if (addon.priceWithMarkup) {
        if (addon.perPerson && guest) {
          return total + Number(addon.priceWithMarkup) * Number(guest);
        } else {
          return total + Number(addon.priceWithMarkup);
        }
      }
    },
    0
  );

  const totalAddonsCost = selectedAddOns?.reduce((total, addon) => {
    if (addon.perPerson && guest) {
      return total + Number(addon.finalAddonPrice) * Number(guest);
    } else {
      return total + Number(addon.finalAddonPrice);
    }
  }, 0);

  const [priceLoader, setPriceLoader] = useState(false);

  const getRatesFromApi = async (
    packageHub,
    packageDestination,
    todatDays,
    totalNights,
    selectedVehicle
  ) => {
    setPriceLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);
    const destinationNames = packageDestination?.map((dest) => dest.name);

    const formdata = new FormData();
    formdata.append("hub", packageHub);
    destinationNames?.forEach((name) => {
      formdata.append("destinations[]", name);
    });
    formdata.append("days", todatDays);
    formdata.append("nights", totalNights);
    formdata.append("vehicle_type", selectedVehicle);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    const MIN_LOADING_TIME = 800;

    try {
      const startTime = Date.now();
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/transport-fixed-rates/fetch`,
        requestOptions
      );
      const result = await response.json();
      setRatesOfPackages(result?.data[0]);

      const timeElapsed = Date.now() - startTime;
      const remainingTime = MIN_LOADING_TIME - timeElapsed;

      if (remainingTime > 0) {
        setTimeout(() => setPriceLoader(false), remainingTime);
      } else {
        setPriceLoader(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setPriceLoader(false);
    }
  };

  useEffect(() => {
    if (
      singleTransportData?.packageHub &&
      singleTransportData?.packageDestination &&
      singleTransportData?.totalDays &&
      singleTransportData?.totalNights &&
      selectedVehicle
    ) {
      getRatesFromApi(
        singleTransportData?.packageHub,
        singleTransportData?.packageDestination,
        singleTransportData?.totalDays,
        singleTransportData?.totalNights,
        selectedVehicle
      );
    }
  }, [singleTransportData, selectedVehicle]);

  // reusable fn
  function calculateFinalPrice(basePrice, markupData, commissionData) {
    let finalPrice = 0;
    let priceAfterMarkup = 0;

    if (!basePrice || typeof basePrice !== "number" || basePrice <= 0) {
      return;
    }

    finalPrice = basePrice;

    if (markupData?.markupType && markupData?.amount) {
      if (markupData.markupType === "percentage") {
        finalPrice += (basePrice * markupData.amount) / 100;
      } else if (markupData.markupType === "fixed") {
        finalPrice += Number(markupData.amount);
      }
    }
    priceAfterMarkup = finalPrice;

    return { finalPrice, priceAfterMarkup };
  }

  function calculateTotalAmount(
    basePrice = 0,
    selectedAutomaticDiscount,
    selectedDiscount,
    // discount = 0,
    // discountType = "fixed",
    guest = 2,
    ratesOfPackages,
    childAgeArray,
    totalAddonsCost,
    totalAddonsCostWithoutCommission,
    volvoAddonPrice,
    markupData,
    commissionAmount,
    commissionType
  ) {
    const childWithAgeGreaterThanSix = childAgeArray.filter(
      (age) => age > 6
    )?.length;
    const childWithAgeLessThanSix = childAgeArray.filter(
      (age) => age <= 6
    )?.length;

    const perPaxCount =
      Number(bookingData.guest) +
      childAgeArray?.length +
      ratesOfPackages?.ExtraAdultCount;

    guest = Number(guest);

    // discount = Number(discount);

    let startingPrice = basePrice;

    let markupAmount;
    let commissionAmt;

    if (markupData?.markupType) {
      if (markupData?.markupType === "percentage") {
        markupAmount = (basePrice * markupData?.amount) / 100;
      } else {
        markupAmount = Number(markupData?.amount);
      }
    }
    let onlyAdultCost = 0;
    if (markupAmount && basePrice) {
      basePrice = Number(basePrice) + markupAmount;
      // onlyAdultCost = Number(basePrice) + markupAmount;
    }

    // onlyAdultCost = basePrice * guest;
    // basePrice = basePrice * guest;

    let adjustedPackagePrice = startingPrice;

    let adultCosts = 0;
    let extraAdultSavings = 0;

    if (ratesOfPackages?.ExtraAdultCount) {
      adultCosts =
        Number(ratesOfPackages?.ExtraAdultCount) *
        Number(ratesOfPackages?.ExtraAdult);

      // const preExtraAdultPrice = adultCosts;
      let extraAdultMarkuoAmount;
      let extraAdultCommissionAmount;

      if (markupData?.markupType) {
        if (markupData?.markupType === "percentage") {
          extraAdultMarkuoAmount = (adultCosts * markupData?.amount) / 100;
        } else {
          extraAdultMarkuoAmount = Number(markupData?.amount);
        }
      }

      if (adultCosts && extraAdultMarkuoAmount) {
        adultCosts += extraAdultMarkuoAmount;
      }

      const preExtraAdultPostMarkup = adultCosts;

      // if (commissionAmount && commissionType) {
      //   if (commissionType === "percentage") {
      //     extraAdultCommissionAmount =
      //       (Number(adultCosts) * Number(commissionAmount)) / 100;
      //   } else if (commissionType === "fixed") {
      //     extraAdultCommissionAmount = Number(commissionAmount);
      //   }
      // }

      // if (adultCosts && extraAdultCommissionAmount) {
      //   adultCosts -= extraAdultCommissionAmount
      // }

      basePrice = basePrice + adultCosts;
      const postExtraAdultPrice = adultCosts;

      extraAdultSavings = preExtraAdultPostMarkup - postExtraAdultPrice;
    }

    let childCosts = 0;
    let childCostWithBed = 0;
    let childCostWithOutBed = 0;
    let childSavingsWithBed = 0;
    let childSavingsWithoutBed = 0;

    if (childAgeArray?.length > 0) {
      childAgeArray.forEach((age) => {
        if (Number(age) >= 6) {
          // childCostWithBed += Number(calculateFinalPrice(ratesOfPackages?.ChildWithBedCost, markupData, commission));
          const result = calculateFinalPrice(
            ratesOfPackages?.ChildWithBedCost,
            markupData,
            commission
          );

          childCostWithBed += Number(result?.finalPrice);
          // childSavingsWithBed += Number(result?.priceAfterMarkup - result?.finalPrice);
        } else {
          const result = calculateFinalPrice(
            ratesOfPackages?.ChildWithOutBedCost,
            markupData,
            commission
          );

          if (volvoAddonPrice !== undefined) {
            const volvoCost =
              +volvoAddonPrice / Number(childWithAgeLessThanSix);
            childCostWithOutBed +=
              Number(result?.finalPrice) + result?.volvoCost;
            // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
          } else {
            childCostWithOutBed += Number(result?.finalPrice);
            // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
          }
        }
      });
    }

    // if (commissionAmount && commissionType && totalAddonsCostWithoutCommission && totalAddonsCost) {
    //   totalAgentSavings += (totalAddonsCostWithoutCommission - totalAddonsCost)
    // }

    let totalChildCostPrice = childCostWithBed + childCostWithOutBed;

    if (totalChildCostPrice) {
      basePrice += totalChildCostPrice;
    }

    let discountAmount;

    const calculateAutomaticDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedAutomaticDiscount &&
        selectedAutomaticDiscount?.length > 0 &&
        selectedAutomaticDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };

    const calculateDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedDiscount &&
        selectedDiscount?.length > 0 &&
        selectedDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };

    const totalBookingAutomaticDiscountAmount =
      calculateAutomaticDiscountedAmount(basePrice);
    const totalBookingDiscountAmount = calculateDiscountedAmount(
      Number(basePrice) -
        Number(
          totalBookingAutomaticDiscountAmount
            ? totalBookingAutomaticDiscountAmount
            : 0
        )
    );

    discountAmount =
      Number(totalBookingAutomaticDiscountAmount) +
      Number(totalBookingDiscountAmount);
    // if (discountType === "percentage") {
    //   discountAmount = (basePrice * discount) / 100;
    // } else {
    //   discountAmount = discount;
    // }

    const priceAfterDiscount = basePrice - discountAmount;

    let calculatedCommissionAmount;

    if (commissionAmount && commissionType) {
      if (commission.commissionType === "percentage") {
        calculatedCommissionAmount =
          (priceAfterDiscount * commission.commissionAmount) / 100;
      } else if (commission.commissionType === "fixed") {
        calculatedCommissionAmount = commission.commissionAmount;
      }
    }

    let subtotal;
    if (calculatedCommissionAmount) {
      subtotal = priceAfterDiscount - calculatedCommissionAmount;
    } else {
      subtotal = priceAfterDiscount;
    }

    if (totalAddonsCost) {
      subtotal += totalAddonsCost;
    }

    const gst = subtotal * 0.05;

    const totalAmount = subtotal + gst;

    const discountPercentage = (discountAmount / basePrice) * 100;

    return {
      basePrice: basePrice.toFixed(2),
      discount: discountAmount.toFixed(2),
      priceAfterDiscount: priceAfterDiscount.toFixed(2),
      gst: gst.toFixed(2),
      totalAmount: totalAmount.toFixed(2),
      discountAmount: discountAmount.toFixed(2),
      discountPercentage: discountPercentage,
      // discountType,
      taxAmount: gst.toFixed(2),
      ExtraAdultCost: adultCosts,
      childCosts,
      childCostWithBed,
      childCostWithOutBed,
      totalChildCostPrice,
      adultNumber: guest,
      onlyAdultCost: onlyAdultCost,
      extraAdultNumber: ratesOfPackages?.ExtraAdultCount,
      extraAdultCost: adultCosts,
      childNumber: childAgeArray?.length,

      perPaxCount,
      perPaxCost: (totalAmount / perPaxCount).toFixed(2),
      calculatedAgentAmount: commissionAmt * guest,
      calculatedCommissionAmount,

      extraAdultSavings,
      childSavingsWithBed,
      childSavingsWithoutBed,
      subtotal,
    };
  }

  const handleDiscountChange = (item) => {
    setSelectedDiscount([item]);
  };

  const selectedPrice =
    ACtype === "withAC"
      ? ratesOfPackages?.PriceWithAC
      : ratesOfPackages?.PriceWithoutAC;

  const calculationsOfPackages = calculateTotalAmount(
    selectedPrice,
    selectedAutomaticDiscount,
    selectedDiscount,
    ratesOfPackages?.NoPax,
    ratesOfPackages,
    bookingData?.childAge ? bookingData?.childAge : [],
    totalAddonsCost,
    totalAddonsCostWithoutCommission,
    "",
    markupData,
    commissionAmount,
    commissionType
  );

  useEffect(() => {
    if (!ratesOfPackages) return;

    setPriceLoader(true);
    const delay = setTimeout(() => {
      setPriceLoader(false);
    }, 800); // 800ms minimum loader time

    return () => clearTimeout(delay);
  }, [ACtype]);

  const navigateToCheckOutTransport = () => {
    navigate(`/checkout-transport`, {
      state: {
        transportData: singleTransportData,
        bookingData: bookingData,
        selectedVehicle: selectedVehicle,
        selectedCategory: selectedCategory,
        calculationsOfPackages: calculationsOfPackages,
        selectedAddOns: selectedAddOns,
        customized: false,
        ratesOfPackages,
        markupData,
        selectedMealPlan: selectedMealPlan,
        allPackageHotels: allPackageHotels,
        commission: commission,
        // roomsDetails: roomsDetails,
        totalAddonsCost: totalAddonsCost,
        totalAddonsCostWithoutCommission: totalAddonsCostWithoutCommission,
        selectedAutomaticDiscount: selectedAutomaticDiscount,
        selectedDiscount: selectedDiscount,
        selectedVehicle: selectedVehicle,
      },
    });
  };

  const under6AgeChildren = bookingData?.childAge?.filter(
    (age) => Number(age) < 6
  );
  const over6AgeChildren = bookingData?.childAge?.filter(
    (age) => Number(age) >= 6
  );

  // const checkDates = (startDate, endDate) => {
  //   const currentDate = new Date();
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);

  //   return currentDate >= start && currentDate <= end;
  // };

  // const checkBookingDates = (
  //   checkinBookingDate,
  //   checkoutBookingDate,
  //   discountStartDate,
  //   discountEndDate
  // ) => {
  //   const checkin = new Date(checkinBookingDate);
  //   const checkout = new Date(checkoutBookingDate);
  //   const discountStart = new Date(discountStartDate);
  //   const discountEnd = new Date(discountEndDate);

  //   return checkin <= discountEnd && checkout >= discountStart;
  // };

  const [isExpanded, setIsExpanded] = useState(true);
  const [isExpandedAddon, setIsExpandedAddon] = useState(false);

  const toggleAccordionAddon = () => {
    setIsExpandedAddon(!isExpandedAddon);
  };

  const checkDates = (startDate, endDate) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const start = startDate.split("T")[0];
    const end = endDate.split("T")[0];
    return (
      getCurrentDateFormatted() >= start && getCurrentDateFormatted() <= end
    );
  };

  const checkBookingDates = (
    checkinBookingDate,
    checkoutBookingDate,
    discountStartDate,
    discountEndDate
  ) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const checkin = checkinBookingDate?.split("T")[0];
    const checkout = checkoutBookingDate?.split("T")[0];
    const discountStart = discountStartDate?.split("T")[0];
    const discountEnd = discountEndDate?.split("T")[0];

    return checkin <= discountEnd && checkout >= discountStart;

    // return (
    //   getCurrentDateFormatted() >= discountStart &&
    //   getCurrentDateFormatted() <= discountEnd &&
    //   checkout >= discountStart &&
    //   checkin <= discountEnd
    // );
  };

  const isPromotionApplicable = (userType, userId, promotionApplicable) => {
    if (
      Array.isArray(promotionApplicable) &&
      promotionApplicable.length === 0
    ) {
      return true;
    }

    if (promotionApplicable) {
      return promotionApplicable?.some((applicable) => {
        return (
          applicable?.applicableTo === userType &&
          applicable?.applicableIds?.includes(userId?.toString())
        );
      });
    }
  };

  const isBlackoutDate = (blackoutDates, checkDate) => {
    const normalizedCheckDate = new Date(checkDate).toLocaleDateString("en-CA");
    return blackoutDates.some((blackout) => {
      const blackoutDate = new Date(blackout.date).toISOString().split("T")[0];
      return blackoutDate === normalizedCheckDate;
    });
  };

  // const isPromotionApplicableForEntity = (
  //   promotionEntities,
  //   currentEntityType,
  //   currentEntityId
  // ) => {
  //   return promotionEntities.some((entity) => {
  //     return (
  //       entity.entityType === currentEntityType &&
  //       entity?.entityIds?.some((id) => Number(id) === Number(currentEntityId))
  //     );
  //   });
  // };

  const isPromotionApplicableForEntity = (
    promotionEntities,
    currentEntityType,
    currentEntityId
  ) => {
    return promotionEntities.some((entity) => {
      return (
        entity.entityType === currentEntityType &&
        entity?.entityIds?.some((id) => Number(id) === Number(currentEntityId))
      );
    });
  };

  const evaluateConditions = (conditions, validity) => {
    if (conditions.length === 0) {
      return true;
    }
    const evaluateCondition = (condition, dateToCheck) => {
      const { conditionType, conditionCondition, conditionValue } = condition;
      let startDate = new Date();
      let endDate = new Date();
      endDate.setDate(startDate.getDate() + 1);
      let inputDate = new Date(dateToCheck);
      let currentDate = new Date(currentDateSingle);
      let comparisonValue;
      let valueToCompare;

      const los = calculateLOS(startDate, endDate);

      if (conditionType === "booking_date") {
        comparisonValue = moment(currentDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(currentDate);
        valueToCompare = new Date(conditionValue);
      } else if (conditionType === "LOS") {
        comparisonValue = los;
        valueToCompare = conditionValue;
      } else {
        comparisonValue = moment(inputDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(inputDate);
        valueToCompare = new Date(conditionValue);
      }

      switch (conditionCondition) {
        case "=":
          return comparisonValue.getTime() === valueToCompare.getTime();
        case ">":
          return comparisonValue > valueToCompare;
        case "!=":
          return comparisonValue != valueToCompare;
        case ">=":
          return comparisonValue >= valueToCompare;
        case "<":
          return comparisonValue < valueToCompare;
        case "<=":
          return comparisonValue <= valueToCompare;
        default:
          return false;
      }
    };

    // let result = conditions.length > 0 ? true : false;

    // for (const condition of conditions) {
    //   const conditionResult = evaluateCondition(condition, validity);

    //   if (condition.logicalCondition === "OR" || !conditions.length === 1) {
    //     result = result || conditionResult;
    //   } else {
    //     result = result && conditionResult;
    //   }
    // }
    // return result;

    if (conditions.length === 1) {
      return evaluateCondition(conditions[0], validity);
    }

    const logicalCondition = conditions[0].logicalCondition || "AND";

    let result = logicalCondition === "AND" ? true : false;

    for (const condition of conditions) {
      const conditionResult = evaluateCondition(condition, validity);

      if (logicalCondition === "OR") {
        result = result || conditionResult;
      } else {
        result = result && conditionResult;
      }
    }

    return result;
  };

  const fetchPromotions = async ({
    checkInDateFromBooking,
    packageIdFromBooking,
  }) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
      myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/promotions`,
        requestOptions
      );
      const result = await response.json();
      setPromotions(result?.data);

      const applicableAutomaticPromotion = result?.data
        ?.filter((item) => {
          const isAutomatic = item.promotionType === "automatic";

          const isValidDate = checkDates(item.startDate, item.endDate);

          const isBookingWithinDiscount = checkBookingDates(
            checkInDateFromBooking,
            checkInDateFromBooking,
            item.startDate,
            item.endDate
          );

          const isUserEligible = isPromotionApplicable(
            userType === "customer"
              ? "customers"
              : userType === "agent"
              ? "agents"
              : "",
            userDetails?.id,
            item.promotionApplicable
          );

          const blackoutDates = item.promotionBlackOutDate || [];

          const isBlackout = isBlackoutDate(
            blackoutDates,
            checkInDateFromBooking
          );

          const isApplicableForEntity = isPromotionApplicableForEntity(
            item.promotionEntity,
            "transport",
            packageIdFromBooking
          );

          const isConditionsValid = evaluateConditions(
            item.promotionConditions,
            checkInDateFromBooking
          );

          return (
            isAutomatic &&
            isValidDate &&
            isBookingWithinDiscount &&
            isUserEligible &&
            !isBlackout &&
            isApplicableForEntity &&
            isConditionsValid
          );
        })
        ?.sort((a, b) => b.stackable - a.stackable);

      let selectedPromotions = [];

      if (applicableAutomaticPromotion.length > 0) {
        const firstPromotion = applicableAutomaticPromotion[0];
        selectedPromotions.push(firstPromotion);

        if (applicableAutomaticPromotion.length > 1) {
          const secondPromotion = applicableAutomaticPromotion[1];
          if (firstPromotion.stackable && secondPromotion.stackable) {
            selectedPromotions.push(secondPromotion);
          }
        }
      }

      setSelectedAutomaticDiscount(selectedPromotions);
    } catch (error) {
      console.error("Error fetching promotions:", error);
    }
  };

  const fetchCommissions = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: urlencoded,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/commission/package/${packageId}`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        if (
          data?.data?.commissionType != "none" &&
          data?.data?.commissionAmount !== 0
        ) {
          setCommission(data?.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (packageId && userType === "agent") {
      fetchCommissions();
    }
  }, [packageId, userType]);
  const mainFilters = [
    { label: "Detailed Itinerary", value: "detailed_itinerary" },
    { label: "Inclusions & Exclusions", value: "inclusion_exclusion" },
    { label: "Points To Remember", value: "points_to_remember" },
    { label: "Cancellation Policy", value: "cancellation_policy" },
  ];
  const [activeFilter, setActiveFilter] = useState("overview");
  const [showAllTabs, setShowAllTabs] = useState(false);

  const handleTabClick = (value) => {
    if (value === "overview") {
      setShowAllTabs(!showAllTabs); // Toggle visibility of other tabs
    }
    setActiveFilter(value);
  };
  // Filter Scroll Section
  const handleScrollToSection = (sectionValue) => {
    setFilter(sectionValue);

    const section = document.getElementById(sectionValue);
    if (section) {
      const headerHeight =
        document.querySelector("#NewUIHeader")?.offsetHeight || 0;
      const searchFormHeight =
        document.querySelector("#HotelEditSearchForm")?.offsetHeight || 0;
      const totalOffset = headerHeight + searchFormHeight + 50; // Adding extra spacing
      const sectionPosition =
        section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionPosition - totalOffset,
        behavior: "smooth",
      });
    }

    // setOpenOuterAccordion((prev) => {
    //   if (prev.includes(sectionValue)) {
    //     return prev.filter((item) => item !== sectionValue);
    //   } else {
    //     return [...prev, sectionValue];
    //   }
    // });

    setOpenOuterAccordion([sectionValue]);

    setShowAllTabs(false);
  };

  return (
    <>
      <NewUiHeader />
      {/* <EditNewUiSearchFormTransport
        includingDestinations={includingDestinations}
      /> */}
      <PageMetaData
        title={`${
          singleTransportData?.metaData?.metaTitle
            ? singleTransportData.metaData.metaTitle
            : singleTransportData?.packageName || ""
        } `}
        description={
          singleTransportData?.metaData?.metaDescription
            ? singleTransportData.metaData.metaDescription
            : ""
        }
        keywords={
          singleTransportData?.metaData?.metaKeywords
            ? singleTransportData.metaData.metaKeywords
            : ""
        }
      />
      <OgMetaTitles
        title={`${
          singleTransportData?.packageName &&
          singleTransportData?.packageName !== "" &&
          singleTransportData?.packageName !== undefined &&
          singleTransportData?.packageName
        } - Mountain Mysteries`}
        type="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        url={`https://www.mountainmysteries.com/package/${singleTransportData?.packagehandle}?location=&guest=2&children=0&packagehandle=${singleTransportData?.packagehandle}#package-information`}
      />
      {/* new ui */}
      <div className={styles.section_with_background}>
        <div className={styles.container}>
          {/* Package Main Heading */}
          <div>
            <div className={styles.top_transport}>
              <div>
                {loader ? (
                  <Skeleton width={100} />
                ) : (
                  <div className="flex flex_gap_10">
                    <div className={`${styles.days_and_night} flex`}>
                      <span className="flex align_items_center">
                        <SvgClock />
                      </span>
                      <span>
                        {singlePackage?.totalDays}D /{" "}
                        {singlePackage?.totalNights}N
                      </span>
                    </div>
                    <div
                      className={`${styles.starting_location} font_12 flex align_items_center`}
                    >
                      <span className="flex align_items_center">
                        <SvgLocation />
                      </span>
                      {singlePackage?.packageHub}
                    </div>
                  </div>
                )}

                {/* Package Name */}
                {loader ? (
                  <Skeleton width={400} height={25} />
                ) : (
                  <div className={styles.package_name}>
                    <h4>{singlePackage?.packageName}</h4>
                  </div>
                )}

                <div className="flex justify_content_between align_items_center">
                  {/* Package Destinations */}
                  <div className={styles.all_destinations_wrapper}>
                    {allDestinations &&
                      allDestinations.length > 0 &&
                      allDestinations.map((item, index) => (
                        <div
                          key={index}
                          className={styles.all_destinations_card}
                        >
                          {item.night}N {item.destination}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              {/* Download / Share / Mail / Print */}
              {loader ? (
                <div className={styles.options_btns_wrapper}>
                  <div className={styles.options_btns_card}>
                    <Skeleton width={40} height={20} />
                  </div>
                  <div className={styles.options_btns_card}>
                    <Skeleton width={40} height={20} />
                  </div>
                  {/* <div className={styles.options_btns_card}>
                    <Skeleton width={40} height={20} />
                  </div> */}
                  <div className={styles.options_btns_card}>
                    <Skeleton width={40} height={20} />
                  </div>
                </div>
              ) : (
                <div className={styles.options_btns_wrapper}>
                  <div className={styles.options_btns_card}>
                    <span className="flex align_items_center">
                      <PackageDetails
                        packageData={singlePackage}
                        setOpenGetQuotePopup={setOpenGetQuotePopup}
                        selectedCategory={selectedCategory}
                        allPackageHotels={allPackageHotels}
                      />
                    </span>
                  </div>
                  <div className={styles.vertical_line}></div>
                  <div className={styles.options_btns_card}>
                    <span className="flex align_items_center">
                      <NewShare singlePackageData={singlePackage} />
                    </span>
                  </div>
                  <div className={styles.vertical_line}></div>
                  <div className={styles.options_btns_card}>
                    <span className="flex align_items_center">
                      <NewPrint packageData={singlePackage} />
                    </span>
                  </div>
                </div>
              )}
            </div>

            {/* Gallery Section */}

            {loader ? (
              <div className="overview-content loading-filter-main">
                {Array.from({ length: 1 }).map((_, index) => (
                  <div className="gallery" key={index}>
                    <div>
                      <Skeleton height={350} />
                    </div>
                    <div className="gallery2">
                      <div>
                        <Skeleton height={170} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={170} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={170} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={170} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.flex_gallery_sec}>
                {/* Gallery */}
                {singlePackage?.packageImages?.length > 0 && (
                  <div className={styles.gallery_big}>
                    {singlePackage?.packageImages?.length > 0 ? (
                      <img src={singlePackage.packageImages[0]} alt="" />
                    ) : (
                      <img src={imgNotFound} alt="Image not found" />
                    )}
                  </div>
                )}

                {/* Gallery Small */}
                <div className={styles.gallery_small}>
                  {singlePackage?.packageImages?.length > 0 &&
                    singlePackage?.packageImages
                      .slice(1, 3)
                      .map((item, index) => (
                        <div key={index} className={styles.gallery_small_card}>
                          {singlePackage?.packageImages?.length > 0 ? (
                            <img src={item} alt="" />
                          ) : (
                            <img src={imgNotFound} alt="Image not found" />
                          )}
                        </div>
                      ))}
                </div>

                {/* Package Highlights */}
                <div className={styles.package_highlights}>
                  {" "}
                  {singlePackage?.packageImages?.length > 0 ? (
                    <img
                      src={
                        singlePackage.packageImages &&
                        singlePackage.packageImages[0] &&
                        singlePackage.packageImages[0]
                      }
                      alt=""
                    />
                  ) : (
                    <img src={imgNotFound} alt="Image not found" />
                  )}
                  {/* <div className={styles.package_highlights_heading}>
                  Package Highlights
                </div>
                <div className={styles.package_highlights_content}>
                  <h6>Transfer</h6>
                  <p>Inova Crysta</p>
                </div>
                <div className={styles.package_highlights_content}>
                  <h6>Stay</h6>
                  <p>4 Star Hotel</p>
                </div>
                <div className={styles.package_highlights_content}>
                  <h6>Meals</h6>
                  <p>
                    Lorem ipsum dolor sit amet consectetur. Sapien rutrum eu.
                  </p>
                </div>
                <div className={styles.package_highlights_content}>
                  <h6>Activity</h6>
                  <p>Paragliding at Dharmshala</p>
                </div>

                <div className={styles.highlights_button}>All Highlights</div> */}
                </div>
              </div>
            )}
          </div>
        </div>
        {/*  */}
        <section
          className={`${styles.section_with_background} ${styles.main_details_section}`}
          style={{ paddingTop: "0" }}
        >
          {/* Filter Section */}
          <div className={`${styles.filter_section}`}>
            <div className={styles.container_inside}>
              <div className={styles.filter_wrapper}>
                {mainFilters.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => handleScrollToSection(item.value)}
                    className={`${styles.filter_card} ${
                      filter === item.value ? styles.active_filter : ""
                    }`}
                  >
                    {item.label}
                  </div>
                ))}{" "}
              </div>
              <div className={styles.mobile_filter_wrapper}>
                {mainFilters
                  .filter((item) => item.value !== "overview")
                  .map((item, index) => (
                    <div
                      key={index}
                      onClick={() => handleScrollToSection(item.value)}
                      className={`${styles.filter_card} ${
                        filter === item.value ? styles.active_filter : ""
                      }`}
                    >
                      {item.label}{" "}
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className={styles.container_withoutBg}>
            <div className={styles.main_details}>
              <div className={styles.left_wrapper}>
                {/* Details Itinerary */}
                {singlePackage?.packageItinerary?.length > 0 && (
                  <div
                    className={styles.left_wrapper_inner}
                    id="detailed_itinerary"
                  >
                    {/* <h6>Detailed Itinerary</h6> */}
                    <div
                      className={styles.parent_div}
                      onClick={() =>
                        setOpenOuterAccordion((prev) => {
                          if (prev.includes("detailed_itinerary")) {
                            return prev.filter(
                              (item) => item !== "detailed_itinerary"
                            );
                          } else {
                            return ["detailed_itinerary"];
                          }
                        })
                      }
                    >
                      <h6>Detailed Itinerary</h6>

                      <span
                        className={`${styles.accordion_icon} ${
                          openOuterAccordion.includes("detailed_itinerary")
                            ? styles.active
                            : ""
                        }`}
                      >
                        <SvgAccordion />
                      </span>
                    </div>

                    {openOuterAccordion.includes("detailed_itinerary") && (
                      <div
                        className={styles.detailed_itinerary_overview_content}
                      >
                        {singlePackage?.packageItinerary?.length > 0 &&
                          singlePackage?.packageItinerary.map((item, index) => (
                            <div
                              className={
                                styles.detailed_itinerary_overview_content_card
                              }
                            >
                              <div
                                style={{
                                  border:
                                    openIndex === index
                                      ? "0.5px solid #333"
                                      : "0.5px solid #ccc",
                                }}
                                onClick={() => toggleAccordion(index)}
                                className={`${styles.detailed_itinerary_overview_content_card_top} pointer`}
                              >
                                <div
                                  className={
                                    styles.detailed_itinerary_overview_content_card_heading
                                  }
                                >
                                  <span>Day {index + 1}</span>

                                  <div
                                    className={
                                      styles.detailed_itinerary_overview_content_card_heading_inner_parent
                                    }
                                  >
                                    <div
                                      className={
                                        styles.detailed_itinerary_overview_content_card_heading_right_upper
                                      }
                                    >
                                      {item?.startDestination} to{" "}
                                      {item?.endDestination}
                                    </div>
                                    <div
                                      className={
                                        styles.details_itinerary_start_end_destination
                                      }
                                    >
                                      Starts At: {item?.startDestination} | Ends
                                      At: {item?.endDestination}
                                    </div>
                                  </div>
                                </div>
                                <span
                                  className={`${styles.accordion_icon} ${
                                    openIndex === index ? styles.active : ""
                                  }`}
                                >
                                  <SvgAccordion />
                                </span>
                              </div>

                              <div
                                className={`
                                  ${
                                    styles.detailed_itinerary_overview_content_card_bottom
                                  } ${openIndex === index ? styles.open : ""}
                                `}
                              >
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      item?.additionalDetails
                                        ?.short_description,
                                  }}
                                ></p>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      item?.additionalDetails?.long_description,
                                  }}
                                ></p>
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                    {/* {detailedFilter === "gallery" && (
                    <TransportGallery
                      singleTransportData={singleTransportData}
                      loader={loader}
                    />
                  )} */}
                  </div>
                )}

                {/* Inclusions / Exclusions */}
                {singlePackage?.packagePolicies?.length > 0 && (
                  <div
                    id="inclusion_exclusion"
                    className={`${styles.left_wrapper_inner} ${styles.inclusion_exclusion} ${styles.detailed_itinerary}`}
                  >
                    <div
                      className={styles.parent_div}
                      onClick={() =>
                        setOpenOuterAccordion((prev) => {
                          if (prev.includes("inclusion_exclusion")) {
                            return prev.filter(
                              (item) => item !== "inclusion_exclusion"
                            );
                          } else {
                            return ["inclusion_exclusion"];
                          }
                        })
                      }
                    >
                      <h6>Inclusions / Exclusions</h6>

                      <span
                        className={`${styles.accordion_icon} ${
                          openOuterAccordion.includes("inclusion_exclusion")
                            ? styles.active
                            : ""
                        }`}
                      >
                        <SvgAccordion />
                      </span>
                    </div>
                    {openOuterAccordion.includes("inclusion_exclusion") && (
                      <div className={styles.inclusion_exclusion_content}>
                        <div className={styles.inclusion_content}>
                          {singlePackage?.packagePolicies?.length > 0 &&
                            singlePackage?.packagePolicies
                              .filter((item) => item.type === "inclusion")
                              .map((item, index) => (
                                <>
                                  <div
                                    className={styles.inclusion_content_heading}
                                  >
                                    Inclusions
                                  </div>

                                  <div
                                    key={index}
                                    className={`${styles.inner_common_content} ${styles.inclusion_inner_content}`}
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  ></div>
                                </>
                              ))}
                        </div>
                        <div className={styles.exclusion_content}>
                          {singlePackage?.packagePolicies?.length > 0 &&
                            singlePackage?.packagePolicies
                              .filter((item) => item.type === "exclusion")
                              .map((item, index) => (
                                <>
                                  <div
                                    className={styles.exclusion_content_heading}
                                  >
                                    Exclusive
                                  </div>
                                  <div
                                    key={index}
                                    className={`${styles.inner_common_content} ${styles.exclusive_inner_content}`}
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  ></div>
                                </>
                              ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Points To Remember */}
                {singlePackage?.packagePolicies?.filter(
                  (item) => item.type === "points_to_remember"
                )?.length > 0 && (
                  <div
                    id="points_to_remember"
                    // className={styles.left_wrapper_inner}
                    className={`${styles.left_wrapper_inner} ${styles.inclusion_exclusion} ${styles.detailed_itinerary}`}
                  >
                    <div
                      className={styles.parent_div}
                      onClick={() =>
                        setOpenOuterAccordion((prev) => {
                          if (prev.includes("points_to_remember")) {
                            return prev.filter(
                              (item) => item !== "points_to_remember"
                            );
                          } else {
                            return ["points_to_remember"];
                          }
                        })
                      }
                    >
                      <h6>Things to Know</h6>

                      <span
                        className={`${styles.accordion_icon} ${
                          openOuterAccordion.includes("points_to_remember")
                            ? styles.active
                            : ""
                        }`}
                      >
                        <SvgAccordion />
                      </span>
                    </div>
                    {openOuterAccordion.includes("points_to_remember") && (
                      <div className={styles.inner_common_content_style}>
                        {singlePackage?.packagePolicies?.length > 0 &&
                          singlePackage.packagePolicies
                            .filter(
                              (item) => item.type === "points_to_remember"
                            )
                            .map((item, index) => (
                              <div
                                key={index}
                                className={styles.inner_common_content}
                                dangerouslySetInnerHTML={{
                                  __html: item?.content,
                                }}
                              ></div>
                            ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Cancellation Policy */}
                {singlePackage?.packagePolicies?.filter(
                  (item) => item.type === "cancellation_policy"
                )?.length > 0 && (
                  <div
                    id="cancellation_policy"
                    className={styles.left_wrapper_inner}
                  >
                    <div
                      className={styles.parent_div}
                      onClick={() =>
                        setOpenOuterAccordion((prev) => {
                          if (prev.includes("cancellation_policy")) {
                            return prev.filter(
                              (item) => item !== "cancellation_policy"
                            );
                          } else {
                            return ["cancellation_policy"];
                          }
                        })
                      }
                    >
                      <h6>Cancellation Policy</h6>

                      <span
                        className={`${styles.accordion_icon} ${
                          openOuterAccordion.includes("cancellation_policy")
                            ? styles.active
                            : ""
                        }`}
                      >
                        <SvgAccordion />
                      </span>
                    </div>

                    {openOuterAccordion.includes("cancellation_policy") && (
                      <div className={`${styles.inner_common_content_style}`}>
                        {singlePackage?.packagePolicies?.length > 0 &&
                          singlePackage.packagePolicies
                            .filter(
                              (item) => item.type === "cancellation_policy"
                            )
                            .map((item, index) => (
                              <div
                                key={index}
                                className={styles.inner_common_content}
                                dangerouslySetInnerHTML={{
                                  __html: item?.content,
                                }}
                              ></div>
                            ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className={styles.right_wrapper}>
                <div
                  className="common_background common_background_parent_sticky"
                  style={{ marginBottom: "0" }}
                >
                  <div className="bg_white border_box">
                    <div className="p_10_15 border_bottom">
                      <label>Select Vehicle</label>
                      <select
                        className="w-full"
                        name="meal_plan"
                        value={selectedVehicle}
                        onChange={handleSelectVehicleChange}
                      >
                        <option value="" disabled>
                          Select an option
                        </option>
                        <option value="sedan">Sedan</option>
                        <option value="ertiga">Ertiga</option>
                        <option value="innova-crysta">Innova Crysta</option>
                        <option value="maharaja-tempo">Maharaja Tempo</option>
                        <option value="tempo-traveller-twelve-seater">
                          Tempo Traveller
                        </option>
                        <option value="urbenia-twelve-seater">
                          Urbenia-twelve-seater
                        </option>
                      </select>
                    </div>
                    {/* <hr /> */}

                    <div
                      className="p_10_15 border_bottom"
                      style={{ paddingBottom: "0px" }}
                    >
                      <label>Air Preferences:</label>
                      <div>
                        <label
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <input
                            type="radio"
                            name="meal_plan"
                            value="withoutAC"
                            checked={ACtype === "withoutAC"}
                            onChange={(e) => setACtype(e.target.value)}
                          />
                          <span>
                            Selective Cool (Partial AC)
                            <br />
                            <span style={{ fontSize: "11px" }}>
                              Cooling tailored to the terrain.
                            </span>
                          </span>
                        </label>
                        <label
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            marginBottom: "10px",
                          }}
                        >
                          <input
                            type="radio"
                            name="meal_plan"
                            value="withAC"
                            checked={ACtype === "withAC"}
                            onChange={(e) => setACtype(e.target.value)}
                          />
                          <span>
                            Constant Breeze (Full AC)
                            <br />
                            <span style={{ fontSize: "11px" }}>
                              Stay cool at every mile.
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                    {/* )} */}

                    {/* add ons */}
                    <div className={styles.addons_wrapper}>
                      {/* <Link to={"/checkout-package"}> */}

                      {singleTransportData?.packageAddons &&
                        singleTransportData?.packageAddons.length > 0 && (
                          <div className=" pointer">
                            {singleTransportData.packageAddons.some(
                              (item) =>
                                !item.detail.includes("Volvo") &&
                                item.addonType !== "ticket"
                            ) && (
                              <div
                                className="flex align_items_center justify_content_between"
                                onClick={toggleAccordionAddon}
                              >
                                <h5
                                  style={{ color: "#333", fontWeight: "600" }}
                                >
                                  Add Ons
                                </h5>
                                <svg
                                  width="25px"
                                  height="25px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{
                                    cursor: "pointer",
                                    transform: isExpandedAddon
                                      ? "rotate(180deg)"
                                      : "rotate(0deg)",
                                    transition: "transform 0.3s ease",
                                    margin: "0",
                                  }}
                                >
                                  <path
                                    d="M7 10L12 15L17 10"
                                    stroke="#016937"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            )}
                            {/* <div
                              style={{
                                display: isExpandedAddon ? "block" : "none",
                              }}
                              className={styles.addons_wrapper_div}
                            > */}

                            <div
                              className="overflow-width"
                              style={{
                                display: isExpandedAddon ? "block" : "none",
                              }}
                            >
                              {singleTransportData.packageAddons
                                .filter(
                                  (item) =>
                                    !item.detail.includes("Volvo") &&
                                    item.addonType !== "ticket"
                                )
                                .map((item, index) => {
                                  let finalAddonPrice = item?.price;
                                  let priceWithMarkup = item?.price;

                                  if (markupData) {
                                    const markup = markupData;
                                    if (markup.markupType === "percentage") {
                                      finalAddonPrice +=
                                        (item.price *
                                          parseFloat(markup.amount)) /
                                        100;
                                    } else if (markup.markupType === "fixed") {
                                      finalAddonPrice += parseFloat(
                                        markup.amount
                                      );
                                    }
                                  }
                                  priceWithMarkup = finalAddonPrice;

                                  if (
                                    commission?.commissionAmount &&
                                    commission?.commissionType
                                  ) {
                                    if (
                                      commission?.commissionType ===
                                      "percentage"
                                    ) {
                                      finalAddonPrice -=
                                        (Number(finalAddonPrice) *
                                          Number(
                                            commission?.commissionAmount
                                          )) /
                                        100;
                                    } else if (
                                      commission?.commissionType === "fixed"
                                    ) {
                                      finalAddonPrice = Number(
                                        commission?.commissionAmount
                                      );
                                    }
                                  }

                                  return (
                                    <div
                                      key={index}
                                      className={styles.addons_parent}
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        background: selectedAddOns.some(
                                          (addon) => addon.id === item.id
                                        )
                                          ? "#E8F9F1"
                                          : "#fff",
                                        border: selectedAddOns.some(
                                          (addon) => addon.id === item.id
                                        )
                                          ? "none"
                                          : "1px solid #ccc",
                                      }}
                                    >
                                      <div
                                        style={{
                                          cursor: "pointer",
                                          width: "100%",
                                        }}
                                      >
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: 500,
                                            color: selectedAddOns.some(
                                              (addon) => addon.id === item.id
                                            )
                                              ? "#009A50"
                                              : "#222222",
                                          }}
                                        >
                                          {item.detail}{" "}
                                          {commission?.commissionAmount &&
                                            commission?.commissionType && (
                                              <span
                                                style={{
                                                  fontSize: "12px",
                                                  color: "red",
                                                  textDecoration:
                                                    "line-through",
                                                }}
                                              >
                                                {formatIndianCurrency(
                                                  priceWithMarkup
                                                )}{" "}
                                                {item.perPerson
                                                  ? `* ${guest}`
                                                  : ""}
                                              </span>
                                            )}
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              marginTop: "5px",
                                              color: selectedAddOns.some(
                                                (addon) => addon.id === item.id
                                              )
                                                ? "#009A50"
                                                : "#222222",
                                            }}
                                          >
                                            {formatIndianCurrency(
                                              finalAddonPrice
                                            )}{" "}
                                            {item.perPerson ? `* ${guest}` : ""}
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="flex justify_content_end"
                                        style={{ width: "60%" }}
                                      >
                                        <button
                                          style={{ fontSize: "10px" }}
                                          onClick={() =>
                                            handleSelectedAddOns({
                                              ...item,
                                              finalAddonPrice,
                                              priceWithMarkup,
                                            })
                                          }
                                        >
                                          {selectedAddOns.some(
                                            (addon) => addon.id === item.id
                                          ) ? (
                                            <div>
                                              <CrossWithBorder />
                                            </div>
                                          ) : (
                                            <div
                                              style={{
                                                background: "#009A50",
                                                color: "#fff",
                                                padding: "6px 8px",
                                                display: "flex",
                                                fontSize: "12px",
                                              }}
                                            >
                                              {" "}
                                              Add
                                              {/* <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          height="16px"
                                          viewBox="0 -960 960 960"
                                          width="16px"
                                          fill="#ffffff"
                                        >
                                          <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
                                        </svg> */}
                                            </div>
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        )}
                    </div>

                    <div
                      onClick={() => {
                        togglePaymentDetails();
                        handleButtonClick();
                      }}
                      style={{
                        fontSize: "14px",
                        padding: "10px",
                        background: "rgb(253, 247, 228)",
                      }}
                      className="flex justify_content_between align_items_center border_bottom border_top pointer"
                    >
                      <h6 style={{ fontSize: "16px", fontWeight: "600" }}>
                        Price Breakup
                      </h6>
                      <div>
                        {paymentDetails ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="19"
                            viewBox="0 0 18 19"
                            fill="none"
                          >
                            <mask
                              id="mask0_6868_15096"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="18"
                              height="19"
                            >
                              <rect
                                y="0.5"
                                width="18"
                                height="18"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_6868_15096)">
                              <path
                                d="M6.69231 11.8077H3.69231C3.49615 11.8077 3.33177 11.7413 3.19915 11.6085C3.06638 11.4758 3 11.3113 3 11.1152C3 10.9188 3.06638 10.7545 3.19915 10.622C3.33177 10.4894 3.49615 10.4231 3.69231 10.4231H7.24269C7.479 10.4231 7.67715 10.503 7.83715 10.6628C7.997 10.8228 8.07692 11.021 8.07692 11.2573V14.8077C8.07692 15.0038 8.01054 15.1682 7.87777 15.3008C7.745 15.4336 7.58054 15.5 7.38438 15.5C7.18808 15.5 7.02369 15.4336 6.89123 15.3008C6.75862 15.1682 6.69231 15.0038 6.69231 14.8077V11.8077ZM11.3077 7.19231H14.3077C14.5038 7.19231 14.6682 7.25869 14.8008 7.39146C14.9336 7.52423 15 7.68869 15 7.88485C15 8.08115 14.9336 8.24554 14.8008 8.378C14.6682 8.51062 14.5038 8.57692 14.3077 8.57692H10.7573C10.521 8.57692 10.3228 8.497 10.1628 8.33715C10.003 8.17715 9.92308 7.979 9.92308 7.74269V4.19231C9.92308 3.99615 9.98946 3.83177 10.1222 3.69915C10.255 3.56638 10.4195 3.5 10.6156 3.5C10.8119 3.5 10.9763 3.56638 11.1088 3.69915C11.2414 3.83177 11.3077 3.99615 11.3077 4.19231V7.19231Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="19"
                            viewBox="0 0 18 19"
                            fill="none"
                          >
                            <mask
                              id="mask0_6868_15102"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="18"
                              height="19"
                            >
                              <rect
                                y="0.5"
                                width="18"
                                height="18"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_6868_15102)">
                              <path
                                d="M4.38462 14.1154H7.38462C7.58077 14.1154 7.74523 14.1818 7.878 14.3145C8.01062 14.4473 8.07692 14.6118 8.07692 14.8079C8.07692 15.0042 8.01062 15.1686 7.878 15.3011C7.74523 15.4337 7.58077 15.5 7.38462 15.5H3.83446C3.598 15.5 3.39985 15.42 3.24 15.26C3.08 15.1002 3 14.902 3 14.6655V11.1154C3 10.9192 3.06638 10.7548 3.19915 10.622C3.33192 10.4894 3.49638 10.4231 3.69254 10.4231C3.88885 10.4231 4.05323 10.4894 4.18569 10.622C4.31831 10.7548 4.38462 10.9192 4.38462 11.1154V14.1154ZM13.6154 4.88462H10.6154C10.4192 4.88462 10.2548 4.81823 10.122 4.68546C9.98938 4.55269 9.92308 4.38823 9.92308 4.19208C9.92308 3.99577 9.98938 3.83138 10.122 3.69892C10.2548 3.56631 10.4192 3.5 10.6154 3.5H14.1655C14.402 3.5 14.6002 3.58 14.76 3.74C14.92 3.89985 15 4.098 15 4.33446V7.88462C15 8.08077 14.9336 8.24523 14.8008 8.378C14.6681 8.51062 14.5036 8.57692 14.3075 8.57692C14.1112 8.57692 13.9468 8.51062 13.8143 8.378C13.6817 8.24523 13.6154 8.08077 13.6154 7.88462V4.88462Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        padding: "10px",
                        background: "rgb(253, 247, 228)",
                      }}
                    >
                      <>
                        <div className="flex justify_content_between mt-10">
                          <p>
                            <b>Total Cost</b>
                          </p>
                          <span
                            className={`room_text-right alert_text ${
                              Number(calculationsOfPackages?.totalAmount) <=
                                0 && "filterBlur3"
                            }`}
                          >
                            {priceLoader ? (
                              <Skeleton
                                width={80}
                                height={10}
                                borderRadius={4}
                              />
                            ) : (
                              <b>
                                {formatIndianCurrency(
                                  calculationsOfPackages?.basePrice
                                )}
                              </b>
                            )}
                          </span>
                        </div>

                        {activePayment === "priceSummary" && (
                          <>
                            {(selectedAutomaticDiscount.length > 0 ||
                              selectedDiscount.length > 0) && (
                              <div className="mt-10">
                                <p>
                                  <b>
                                    Transport Discount
                                    {selectedAutomaticDiscount?.length > 1
                                      ? "s"
                                      : ""}
                                  </b>
                                </p>
                                {selectedAutomaticDiscount?.map(
                                  (discount, index) => (
                                    <div
                                      className="flex justify_content_between mt-2"
                                      key={discount.id}
                                    >
                                      <span className="discount-name">
                                        {discount.promotionName}
                                      </span>
                                      <span className="room_text-right green">
                                        {discount.promotionMode === "percentage"
                                          ? `${+discount.promotionAmount}%`
                                          : `${formatIndianCurrency(
                                              discount.promotionAmount
                                            )}`}
                                      </span>
                                    </div>
                                  )
                                )}

                                {selectedDiscount &&
                                  selectedDiscount?.length > 0 &&
                                  selectedDiscount?.map((discount, index) => (
                                    <div
                                      className="flex justify_content_between mt-2"
                                      key={discount.id}
                                    >
                                      <span className="discount-name">
                                        {discount.promotionName}
                                      </span>
                                      <span className="room_text-right green">
                                        {discount.promotionMode === "percentage"
                                          ? `${+discount.promotionAmount}%`
                                          : `${formatIndianCurrency(
                                              discount.promotionAmount
                                            )}`}
                                      </span>
                                    </div>
                                  ))}
                              </div>
                            )}

                            {calculationsOfPackages?.discount > 0 && (
                              <div className="flex justify_content_between mt-10 border-bottom-one ">
                                <p>Package Cost (After Disc.)</p>
                                <span
                                  className={`room_text-right ${
                                    Number(
                                      calculationsOfPackages?.totalAmount
                                    ) <= 0 && "filterBlur3"
                                  }`}
                                >
                                  {priceLoader ? (
                                    <Skeleton
                                      width={80}
                                      height={10}
                                      borderRadius={4}
                                    />
                                  ) : (
                                    <>
                                      {formatIndianCurrency(
                                        calculationsOfPackages?.priceAfterDiscount
                                      )}
                                    </>
                                  )}
                                </span>
                              </div>
                            )}

                            {commission &&
                              Object.keys(commission).length > 0 && (
                                <>
                                  <div className="flex justify_content_between mt-10">
                                    <p>
                                      Commission{" "}
                                      <small>
                                        ({" "}
                                        {commission.commissionType ===
                                        "fixed" ? (
                                          <span className="room_text-right">
                                            {formatIndianCurrency(
                                              commission?.commissionAmount
                                            )}
                                          </span>
                                        ) : (
                                          <span className="room_text-right">
                                            {commission?.commissionAmount}%
                                          </span>
                                        )}
                                        )
                                      </small>
                                    </p>

                                    {formatIndianCurrency(
                                      calculationsOfPackages?.calculatedCommissionAmount
                                    )}
                                  </div>
                                </>
                              )}

                            {selectedAddOns && selectedAddOns.length > 0 && (
                              <div className="flex justify_content_between mt-10">
                                <p>Addons Price</p>
                                <span
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "end",
                                  }}
                                >
                                  {commission &&
                                    Object.keys(commission).length > 0 && (
                                      <small
                                        style={{
                                          color: "red",
                                          textDecoration: "line-through",
                                        }}
                                      >
                                        {formatIndianCurrency(
                                          totalAddonsCostWithoutCommission
                                        )}
                                      </small>
                                    )}
                                  <b>{formatIndianCurrency(totalAddonsCost)}</b>
                                </span>
                              </div>
                            )}

                            <div className="flex justify_content_between mt-10">
                              <p>Subtotal </p>
                              <span>
                                {priceLoader ? (
                                  <Skeleton
                                    width={80}
                                    height={10}
                                    borderRadius={4}
                                  />
                                ) : (
                                  <>
                                    {formatIndianCurrency(
                                      calculationsOfPackages?.subtotal
                                    )}
                                  </>
                                )}
                              </span>
                            </div>
                          </>
                        )}

                        <div className="flex justify_content_between mt-10">
                          <p>GST(5%) </p>
                          <span
                            className={`room_text-right  ${
                              Number(calculationsOfPackages?.totalAmount) <=
                                0 && "filterBlur3"
                            }`}
                          >
                            {priceLoader ? (
                              <Skeleton
                                width={80}
                                height={10}
                                borderRadius={4}
                              />
                            ) : (
                              <>
                                {formatIndianCurrency(
                                  calculationsOfPackages?.taxAmount
                                )}
                              </>
                            )}
                          </span>
                        </div>

                        <div className="flex justify_content_between mt-10 border_top pt_10">
                          <div>
                            <b>Total Amount to be paid</b>
                          </div>
                          <div>
                            <span
                              className={` ${
                                Number(calculationsOfPackages?.totalAmount) <=
                                  0 && "filterBlur3"
                              }`}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "end",
                              }}
                            >
                              {priceLoader ? (
                                <Skeleton
                                  width={80}
                                  height={10}
                                  borderRadius={4}
                                />
                              ) : (
                                <b>
                                  {formatIndianCurrency(
                                    calculationsOfPackages?.totalAmount
                                  )}
                                </b>
                              )}
                            </span>
                          </div>
                        </div>

                        <button
                          style={{
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                          onClick={navigateToCheckOutTransport}
                          className={styles.book_btn}
                        >
                          Book Now
                        </button>
                      </>
                    </div>
                  </div>

                  {promotions.length > 0 && (
                    <div>
                      {promotions.some(
                        (item) =>
                          item.promotionType === "coupon" &&
                          (() => {
                            const isValidDate = checkDates(
                              item.startDate,
                              item.endDate
                            );
                            const isBookingWithinDiscount = checkBookingDates(
                              startDate,
                              startDate,
                              item.startDate,
                              item.endDate
                            );
                            const isUserEligible = isPromotionApplicable(
                              userType === "customer"
                                ? "customers"
                                : userType === "agent"
                                ? "agents"
                                : "",
                              userDetails?.id,
                              item.promotionApplicable
                            );
                            const blackoutDates =
                              item.promotionBlackOutDate || [];
                            const isBlackout = isBlackoutDate(
                              blackoutDates,
                              startDate
                            );
                            const isApplicableForEntity =
                              isPromotionApplicableForEntity(
                                item.promotionEntity,
                                "transport",
                                singleTransportData?.packageId
                              );
                            const isConditionsValid = evaluateConditions(
                              item.promotionConditions,
                              startDate
                            );

                            return (
                              isValidDate &&
                              isBookingWithinDiscount &&
                              isUserEligible &&
                              !isBlackout &&
                              isApplicableForEntity &&
                              isConditionsValid
                            );
                          })()
                      ) && (
                        <div className={styles.promotion_wrapper}>
                          <div
                            className={styles.promotion_parent}
                            style={{ marginTop: "10px" }}
                          >
                            <div className="flex justify_content_between cursor_pointer ">
                              <div className="flex justify_content_between w-100">
                                <div>
                                  <h5
                                    style={{ color: "#009a50" }}
                                    className="text-left"
                                  >
                                    Offers
                                  </h5>
                                </div>
                                {selectedDiscount && (
                                  <button
                                    className="view_btn"
                                    onClick={() => setSelectedDiscount([])}
                                  >
                                    clear
                                  </button>
                                )}
                              </div>
                            </div>
                            <div>
                              {promotions?.map((item, index) => {
                                const isCouponCode =
                                  item?.promotionType === "coupon"
                                    ? true
                                    : false;
                                const isValidDate = checkDates(
                                  item.startDate,
                                  item.endDate
                                );
                                const isBookingWithinDiscount =
                                  checkBookingDates(
                                    startDate,
                                    startDate,
                                    item.startDate,
                                    item.endDate
                                  );
                                const isUserEligible = isPromotionApplicable(
                                  userType === "customer"
                                    ? "customers"
                                    : userType === "agent"
                                    ? "agents"
                                    : "",
                                  userDetails?.id,
                                  item.promotionApplicable
                                );
                                const blackoutDates =
                                  item.promotionBlackOutDate || [];
                                const isBlackout = isBlackoutDate(
                                  blackoutDates,
                                  startDate
                                );
                                const isApplicableForEntity =
                                  isPromotionApplicableForEntity(
                                    item.promotionEntity,
                                    "transport",
                                    singleTransportData?.packageId
                                  );

                                const isConditionsValid = evaluateConditions(
                                  item.promotionConditions,
                                  startDate
                                );

                                return (
                                  isCouponCode &&
                                  isValidDate &&
                                  isBookingWithinDiscount &&
                                  isUserEligible &&
                                  !isBlackout &&
                                  isApplicableForEntity &&
                                  isConditionsValid && (
                                    <div
                                      key={index}
                                      style={{
                                        backgroundColor: selectedDiscount?.some(
                                          (discount) => discount.id === item.id
                                        )
                                          ? "#E8F9F1"
                                          : "#fff",
                                      }}
                                      className={styles?.discountSingleDiv}
                                    >
                                      <div className="flex">
                                        <label
                                          style={{
                                            textTransform: "capitalize",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: selectedDiscount?.some(
                                              (discount) =>
                                                discount.id === item.id
                                            )
                                              ? "#009a50"
                                              : "#333",
                                          }}
                                          htmlFor={item?.promotionName}
                                        >
                                          {" "}
                                          <input
                                            checked={selectedDiscount?.some(
                                              (discount) =>
                                                discount.id === item.id
                                            )}
                                            onChange={() =>
                                              handleDiscountChange(item)
                                            }
                                            type="radio"
                                            id={item.promotionName}
                                          />
                                          <div>
                                            <div>
                                              {item?.promotionName?.replace(
                                                /-/g,
                                                " "
                                              )}
                                            </div>
                                          </div>
                                        </label>
                                      </div>
                                      <div
                                        style={{
                                          color: selectedDiscount?.some(
                                            (discount) =>
                                              discount.id === item.id
                                          )
                                            ? "#009a50"
                                            : "#333",
                                        }}
                                      >
                                        {item?.promotionMode === "fixed" ? (
                                          formatIndianCurrency(
                                            item?.promotionAmount
                                          )
                                        ) : (
                                          <>{item?.promotionAmount}%</>
                                        )}
                                      </div>
                                    </div>
                                  )
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {/* <OurQuery /> */}
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* <Footer /> */}
      <div className={styles.footer_bottom_align}>
        {" "}
        <NewFooterUI />{" "}
      </div>

      <div className={styles.mobile_price_breakup}>
        <div className="">
          <div className="">
            <div>Total Amt.</div>
            <div>
              <span
                className={` ${
                  Number(calculationsOfPackages?.totalAmount) <= 0 &&
                  "filterBlur3"
                }`}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "end",
                }}
              >
                <b>
                  {formatIndianCurrency(calculationsOfPackages?.totalAmount)}
                </b>
              </span>
            </div>
          </div>
        </div>
        <button
          className={styles.book_btn}
          onClick={navigateToCheckOutTransport}
        >
          Continue
        </button>
      </div>
      {showRatePopup && (
        <NewSendEnquiryPopup
          package_id={singleTransportData?.packageId}
          setshowRatePopup={setshowRatePopup}
          typeDetail="package"
        />
      )}
    </>
  );
}

export default NewUiSingleTransport;
